
































































































import { mapState, mapActions } from "vuex";
import TheHeader from "@/common/components/organisms/TheHeader.vue";
import TheFooter from "@/common/components/organisms/TheFooter.vue";
import ItemCarousel from "@/general/components/organisms/ItemCarousel.vue";
import ButtonMain from "@/common/components/atoms/ButtonMain.vue";
import IconBase from "@/common/components/atoms/IconBase.vue";
import TheBreadcrumb from "@/common/components/organisms/TheBreadcrumb.vue";

import TheC01ItemThumbnailsPc from "@/general/components/pages/parts/ProductDetails/TheC01ItemThumbnailsPc.vue";
import TheC01ItemThumbnailsSp from "@/general/components/pages/parts/ProductDetails/TheC01ItemThumbnailsSp.vue";
import TheC01ItemInfo from "@/general/components/pages/parts/ProductDetails/TheC01ItemInfo.vue";
import TheC01ItemForm from "@/general/components/pages/parts/ProductDetails/TheC01ItemForm.vue";
import TheC01ItemDetail from "@/general/components/pages/parts/ProductDetails/TheC01ItemDetail.vue";
import { Prop, Component, Vue } from "vue-property-decorator";
import items from "@/general/store/modules/items";
import commons from "@/common/store/modules/commons";
import globals from "@/general/store/modules/globals";
import {
  addToFavorite,
  deleteFavorites,
  getShoppingCartItems,
  postBrowserHistory,
  productDetail,
  browserHistory,
  getShoppingCartPointSummary,
  getFavorites
} from "@/general/store/api";
import { FavoriteRequest } from "gen/rssapi/api";

import {
  karteView,
  karteItem,
  karteViewItem,
  karteFavorite
} from "@/common/assets/js/karte/";
import LocalStorage from "@/general/utils/storage";
import AuthStorage from "@/general/utils/auth";

@Component({
  components: {
    TheHeader,
    TheFooter,
    ItemCarousel,
    ButtonMain,
    IconBase,
    TheBreadcrumb,
    TheC01ItemThumbnailsPc,
    TheC01ItemThumbnailsSp,
    TheC01ItemInfo,
    TheC01ItemForm,
    TheC01ItemDetail
  }
})
export default class ProductDetails extends Vue {
  cartItem: any = [];
  creditCardEnabled = false;
  item: any = {};
  histories: any = [];
  isFavorite = false;
  favoriteId = 0;
  cartUsedpoints = 0;
  showHistories = false;
  point = 0;
  stock = 9999;
  isQuantityControl = false;
  jan_code = "";
  is_age_alert = false;
  extraProp = [];
  clientList: any = [];
  isBenepoExchange = false;
  isHiddenItem = false;
  breadcrumb = [
    {
      text: "",
      url: "/home",
      pageType: "home"
    },
    {
      text: "製品詳細",
      url: "",
      pageType: "lower"
    }
  ];

  $refs!: {
    theHeader: TheHeader;
  };

  async favorite(skuId: number) {
    const userDetails = JSON.parse(
      LocalStorage.getItem("userDetails") as string
    );
    const favoriteRequest: FavoriteRequest = {
      sku: skuId,
      user: userDetails.id
    };
    const res = await addToFavorite(favoriteRequest);
    this.favoriteId = res.id;
    this.isFavorite = true;

    karteFavorite(true, karteItem(this.item, 0));
  }

  async unfavorite(skuId: number) {
    const fav = await getFavorites();
    const favExist = fav.results?.find(item => {
      return item.sku.id == skuId;
    });

    if (favExist !== undefined) {
      await deleteFavorites(favExist.id);

      karteFavorite(false, karteItem(this.item, 0));

      this.isFavorite = false;
    } else {
      this.isFavorite = false;
    }
  }

  get isSp() {
    return globals.isLargeBreakpointWidthOfSp;
  }

  get skuSet() {
    return this.item.sku_set;
  }
  get id() {
    return this.item && this.item.id ? this.item.id : 0;
  }

  get menuNo() {
    return this.item && this.item.menu_no ? this.item.menu_no : "";
  }

  get status() {
    if (this.item && this.item.sku_set && this.item.sku_set.length > 0) {
      if (
        this.item.sku_set[0].is_quantity_control &&
        this.item.sku_set[0].quantity == 0
      ) {
        //out of stock
        return "在庫なし";
      } else if (this.item.is_new === true) {
        //New
        return "New";
      } else if (this.item.is_featured === true) {
        //Recommended
        return "おすすめ";
      } else {
        //show nothing
        return false;
      }
    } else {
      return false;
    }
  }

  get type() {
    if (this.item.redemption_type == 1) {
      return "normal";
    } else if (this.item.redemption_type == 2) {
      return "gift_card";
    } else {
      return "web_coupon";
    }
  }

  get headerHeight(): number {
    // ランク利用表示フラグを見てヘッダーの高さを変える
    if(commons.userInfo.rankDisplayEnabled === true) {
      return 135;
    }
    return 105;
  }
  get addMarginTop(): any {
    const style = {
      marginTop: this.headerHeight.toString() + "px"
    };
    return this.isSp ? style : "";
  }

  mounted() {
    AuthStorage.checkLogin();
  }

  async created() {
    commons.setOrgPageSpecificDataFromLocalStorage();

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    const id = urlParams.get("id")
      ? parseInt(urlParams.get("id") as string)
      : 0;

    this.item = await productDetail(id);

    if (this.item.client_list && this.item.client_list.length > 0) {
      this.item.client_list.forEach((element: any) => {
        this.clientList.push({
          label: element.company_name + " " + "(" + element.company_cd + ")",
          value: element.customer_no + "," + element.torino_no
        });
      });
      this.isBenepoExchange = true;
    }

    if (!this.isBenepoExchange) {
      if (this.item && this.item.is_hidden_item) {
        this.stock = 0;
        this.isHiddenItem = true;
      } else {
        if (this.item && this.item.sku_set && this.item.sku_set.length > 0) {
          this.isQuantityControl = this.item.sku_set[0].is_quantity_control;
          if (this.isQuantityControl) {
            this.stock = this.item.sku_set[0].quantity;
          } else {
            this.stock = 9999;
          }
        } else {
          this.stock = 0;
          this.isHiddenItem = true;
        }
      }
    }

    if (this.item && this.item.sku_set && this.item.sku_set.length > 0) {
      this.point = this.item.sku_set[0].point_required;
      this.isFavorite = this.item.sku_set[0].favorite_id === 0 ? false : true;
      this.favoriteId = this.item.sku_set[0].favorite_id;
      this.jan_code = this.item.sku_set[0].jan_code
        ? this.item.sku_set[0].jan_code
        : "";
    }
    if (!this.isBenepoExchange) {
      if (
        this.item.sku_set[0].optiontypeextra_set &&
        this.item.sku_set[0].optiontypeextra_set.length > 0
      ) {
        this.extraProp = this.item.sku_set[0].optiontypeextra_set;
        console.log(this.isBenepoExchange);
      }
    }

    if (
      this.item.sku_set[0].optiontypeextra_set &&
      this.item.sku_set[0].optiontypeextra_set.length > 0 &&
      this.item.sku_set[0].optiontypeextra_set[0].name ==
        "私は20歳以上です（はいorいいえ）" &&
      this.item.sku_set[0].optiontypeextra_set[0].regex == "^はい$"
    ) {
      this.is_age_alert = true;
    }

    karteViewItem(karteItem(this.item, 0), this.stock > 0);

    const cartItems = await getShoppingCartItems(1, 90, "");

    LocalStorage.setItem("cartDetails", JSON.stringify(cartItems?.results));
    this.cartItem = cartItems?.results;
    const cartItemCount = cartItems?.count ? cartItems?.count : 0;

    if (cartItemCount > 0) {
      const shoppingCartSummary = await getShoppingCartPointSummary().catch(
        e => {
          return {
            used_points: 0
          };
        }
      );
      this.cartUsedpoints = shoppingCartSummary.used_points;
    }

    if (
      this.creditCardEnabledAdmin == 1 &&
      this.item?.sku_set[0].supplier.credit_card_support &&
      this.item?.tax_rate > 0 &&
      this.userRedeemablePoints > 0
    ) {
      this.creditCardEnabled = true;
    }

    this.getHistories();

    setTimeout(() => {
      if (
        this.item &&
        this.item.categories &&
        this.item.categories.length > 0
      ) {
        if (this.item.categories[0].level == 2) {
          const mainCatName = this.item.categories[0].main_category.name;
          const childCatName = this.item.categories[0].name;
          const mainCatId = this.item.categories[0].main_category.id;
          this.breadcrumb = [
            {
              text: "",
              url: "/home",
              pageType: "home"
            },
            {
              text: mainCatName,
              url: "/product-list/?product-category=" + mainCatId,
              pageType: "lower"
            },
            {
              text: childCatName,
              url: "",
              pageType: "lower"
            }
          ];
        }
      }
      commons.setbreadcrumb(this.breadcrumb);

      this.updateBrowserHistory();
    }, 1000);
  }

  async updateBrowserHistory() {
    const userDetails = JSON.parse(
      LocalStorage.getItem("userDetails") as string
    );

    if (this.item && this.item.sku_set) {
      // DX_IC-374 (ADD_PRODUCT_TO_BROWSER_HISTORY関連のチェックを削除する)
      await postBrowserHistory({
        user: userDetails.id,
        sku: this.item.sku_set[0].id
      });
    }
  }

  get userRedeemablePoints() {
    const userPoints = JSON.parse(
      LocalStorage.getItem("userPointsDetails") as string
    );

    return (
      userPoints.total_points -
      userPoints.thanks_exclusive_points -
      this.cartUsedpoints
    );
  }

  get category() {
    if (this.item && this.item.categories && this.item.categories.length > 0) {
      if (this.item.categories[0].level == 2) {
        return {
          main: this.item.categories[0].main_category.name,
          child: this.item.categories[0].name,
          main_id: this.item.categories[0].main_category.id
        };
      } else {
        return {
          main: "",
          child: "",
          main_id: 0
        };
      }
    } else {
      return {
        main: "",
        child: "",
        main_id: 0
      };
    }
  }

  async getHistories() {
    const favorites = await browserHistory();
    favorites.results?.forEach(item => {
      this.histories.push({
        id: item?.sku?.premium?.id,
        image: this.getImagePath(item?.sku?.premium),
        name: item?.sku?.premium?.name,
        point: item?.sku?.point_required,
        discount_rate: 0,
        is_favorite: false,
        stock: item?.sku?.quantity,
        is_quantity_control: item?.sku?.is_quantity_control,
        colorCode: this.getColor(item?.sku),
        status: this.statusBh(item?.sku)
      });
    });

    const count = favorites.count ? favorites.count : 0;
    if (count > 0) {
      this.showHistories = true;
    }
  }

  getImagePath(premium: any) {
    let imgUrl = "";
    premium?.premiumimage_set?.forEach((img: any) => {
      if (img?.is_primary == true) {
        imgUrl = img?.image_url;
      }
    });

    return imgUrl;
  }

  getColor(item: any) {
    return item.is_quantity_control && item.quantity == 0
      ? "#333"
      : commons.colorCode;
  }

  statusBh(sku: any) {
    if (sku?.is_quantity_control && sku?.quantity == 0) {
      //out of stock
      return "在庫なし";
    } else if (
      sku?.premium?.is_new === true &&
      sku?.premium?.is_featured === false
    ) {
      //New
      return "New";
    } else if (
      sku?.premium?.is_new === false &&
      sku?.premium?.is_featured === true
    ) {
      //Recommended
      return "おすすめ";
    } else if (
      sku?.premium?.is_new === true &&
      sku?.premium?.is_featured === true
    ) {
      //Recommended
      return "おすすめ";
    } else {
      //show nothing
      return "";
    }
  }

  get creditCardEnabledAdmin() {
    // const orgAdminSettings = LocalStorage.getItem("orgAdminSettings")
    //   ? JSON.parse(LocalStorage.getItem("orgAdminSettings") as string)
    //   : [];

    // return orgAdminSettings[0].self_pay_enabled;
    const userDetails = LocalStorage.getItem("userDetails");
    if (userDetails) {
      const userDetailsJson = JSON.parse(userDetails);
      return userDetailsJson.self_pay_enabled;
    }
    return false;
  }
}
